import { MenuHeaderCombinedProps } from './types';

const usePresenter = (props: MenuHeaderCombinedProps): MenuHeaderCombinedProps => {
  return props;
};

export default usePresenter;
